import axios from "axios";

export const nubisDriveCapacityAPI = async () => {
  let response = await axios({
    url: `/api/v2/drive/file/capacity`,
    method: "GET"
  });

  let used = response.data.used_capacity;
  let total = response.data.total_capacity;
  return { used: used, total: total };
};
